import axios from 'axios';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import {
  NodeServer,
  Race,
  avatarBackgroundArr,
  galleryRaceToImgMap,
  getRandomNumber,
} from '../config';

import '../styles/EventAvatars.scss';

interface GalleryItem {
  image: string;
  imageGallery: string | undefined;
  nftId: number;
  raceName: Race;
}

const newNftId = 1324;

function EventAvatars(props: { title: string; id: string }) {
  const PER_PAGE = 28;
  const [loading, setLoading] = useState(true);
  const [gallery, setGallery] = useState([] as GalleryItem[]);
  const [hasMore, setHasMore] = useState(true);
  const [perPage] = useState(PER_PAGE);
  const [page, setPage] = useState(0);
  const [gallerySlice, setGallerySlice] = useState([] as GalleryItem[]);
  const navigate = useNavigate();

  const getRandomColor = () => {
    const h = getRandomNumber(360);
    const s = getRandomNumber(100);
    const l = getRandomNumber(100);

    return `hsl(${h}deg, ${s}%, ${l}%)`;
  };

  const randomRectangles = [...Array(21)].map((item) => getRandomColor());

  const getRandomGradient = () => {
    const index = getRandomNumber(10);
    const { background, backgroundBlendMode } = avatarBackgroundArr[index];
    return { background, backgroundBlendMode };
  };

  const getNftBackground = (item: GalleryItem) => {
    const result =
      item.raceName && item.nftId < newNftId
        ? {
            backgroundImage: `url(${galleryRaceToImgMap[item.raceName]})`,
            backgroundSize: 'cover',
          }
        : getRandomGradient();
    return result;
  };

  const onDivClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.currentTarget.style.backgroundColor = getRandomColor();
  };

  const onAvatarClick = (nftId: number) => {
    navigate(`/avatar?id=${nftId}`);
  };

  const fetchMoreData = () => {
    if (gallerySlice.length >= gallery.length) {
      setHasMore(false);
    } else {
      const startIndex = (page + 1) * perPage;
      const newSlice = gallery.slice(startIndex, startIndex + perPage);
      setGallerySlice(gallerySlice.concat(newSlice));
      setPage(page + 1);
    }
  };

  const resetPaginatinatedItems = () => {
    setHasMore(true);
    setPage(0);
    setGallerySlice([]);
  };

  useEffect(() => {
    resetPaginatinatedItems();
    const getNfts = async () => {
      setLoading(true);
      const response = await axios.get<any>(
        `${NodeServer.baseURL}${NodeServer.nftGallery}${props.id}`,
        { withCredentials: true }
      );
      const nftArr = response?.data as GalleryItem[];
      if (nftArr) {
        const sortedNfts = nftArr.sort((a, b) => (a.nftId > b.nftId ? -1 : 1));
        setGallery(sortedNfts);
        setGallerySlice(sortedNfts.slice(0, PER_PAGE));
        setHasMore(sortedNfts.length > PER_PAGE);
      }
      setLoading(false);
    };
    try {
      getNfts();
    } catch (error) {
      setLoading(false);
    }
  }, [props.id]);

  useEffect(() => {
    document.title = props.title;
  });

  const renderPlaceholders = () => {
    const placeholders = Array.from({ length: 21 });

    return (
        <div className="placeholder-container">
          {placeholders.map((_, index) => (
              <div
                  key={index}
                  className="placeholder-cell"
              />
          ))}
        </div>
    );
  }

  return loading ? (
      renderPlaceholders()
  ) : gallery && gallery.length ? (
    <InfiniteScroll
      className="event-avatars-page"
      dataLength={gallerySlice.length}
      next={fetchMoreData}
      hasMore={hasMore}
      loader={<h4>Loading...</h4>}
    >
      {gallerySlice.map((item, index) => (
        <div
          key={index}
          className="nft-placeholder"
          style={item.nftId < newNftId ? getNftBackground(item) : {}}
          onClick={() => onAvatarClick(item.nftId)}
        >
          <img
            src={item.imageGallery ? item.imageGallery : item.image}
            alt="nft"
          ></img>
        </div>
      ))}
    </InfiniteScroll>
  ) : (
    <div className="event-avatars-page">
      {randomRectangles.map((color, index) => (
        <div
          key={index}
          className="nft-placeholder empty"
          style={{ backgroundColor: color }}
          onClick={onDivClick}
        ></div>
      ))}
    </div>
  );
}

export default EventAvatars;
